import React from 'react';
import { IconName } from '../Icon/IconName';
import GlobalProps from '../globalProps';
import { Paginator } from '../../model/data';
import { PermissionButton } from './PermissionButton';

interface Props<T extends Paginator> extends GlobalProps {
  model: T;
  permission: string;
  onClick: () => void;
  name: IconName;
  loading?: boolean;
  hideLock?: boolean;
  tooltip?: string;
  disabled?: boolean;
}

export function PaginatedPermissionButton<T extends Paginator>(props: Props<T>): JSX.Element | null {
  if (props.model.loading) return null;
  const permissableModel = { $permissions: Array.from(props.model.permissions) };
  const permissionButtonProps = { ...props, model: permissableModel };
  return <PermissionButton {...permissionButtonProps} />;
}
